<template>
  <div class="routelist">
    <ul class="routes">
      <li v-for="route in routen" :style="{ backgroundImage: 'url(' + AbsImagePath(route.MainPic) + ')' }">
        <div class="inner-container">
          <table>
            <tr>
              <td><img src="./../assets/EKSElement-start-path.svg" /></td>
              <td>
                <router-link :to="{ name: 'route', params: { routeId: route.id }}">
                  <template v-if="language=='de'">
                    {{ route.de.Titel }}
                  </template>
                  <template v-if="language=='pl'">
                    {{ route.pl.Titel }}
                  </template>
                  <template v-if="language=='cz'">
                    {{ route.cz.Titel }}
                  </template>
                  <template v-if="language=='en'">
                    {{ route.en.Titel }}
                  </template>
                </router-link>
              </td>
            </tr>
          </table>
        </div>
      </li>
      <div style="clear: both"></div>
    </ul>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'RouteListe',
  props: {
    routen: Array,
  },
  computed: {
    language: function () {
      return this.$root.$i18n.locale
    },
  },
  methods: {
    AbsImagePath(pic) {
      console.log(pic)
      if (window.innerWidth > 800)
        return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/1600x800/' + pic
      else
        return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/800x400/' + pic
    },
  },
}
</script>

<style scoped lang="scss">
.routelist {

  max-width: 1024px;
  margin: 0 auto;
  padding: 0px 80px;
  box-sizing: border-box;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 0px;
  }


  ul.routes {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-flow: wrap;
    flex-direction: column;

    li {
      background-color: transparent;
      background-size: 110%;
      background-repeat: no-repeat;
      background-position: center center;
      border: 0;
      border-radius: 0;
      padding: 30px;
      box-sizing: border-box;
      width: 100%;
      margin-bottom: 0;

      @media screen and (max-width: 480px) {
        padding: 20px;
      }
      @media screen and (max-width: 360px) {
        padding: 15px;
      }

      .inner-container {
        border: 1px solid white;
        box-sizing: border-box;
        width: 100%;
      }

      table {
        padding: 30px;
        box-sizing: border-box;
        width: 100%;

        @media screen and (max-width: 480px) {
          padding: 20px;
        }
        @media screen and (max-width: 360px) {
          padding: 15px;
        }

        tr {
          td {
            box-sizing: border-box;
            text-align: left;

            @media screen and (max-width: 480px) {

            }

            &:nth-child(1) {
              width: 25px;
              vertical-align: top;

              @media screen and (max-width: 480px) {
                width: 20px;
              }
              @media screen and (max-width: 360px) {

              }

              img {
                height: auto;
                width: 100%;
              }
            }
            &:nth-child(2) {
              padding-left: 10px;

              a {

                @media screen and (max-width: 768px) {
                  max-width: 200px;
                }
              }
            }
          }
        }
      }

      img {
        min-width: 20px;
        display: inline-block;
        margin-top: 10px;
      }

      a {
        text-decoration: none;
        text-transform: uppercase;
        color: white;
        display: inline-block;
        font-weight: 700;
        font-family: 'Source Sans Pro', sans-serif;
        font-size: 36px;
        line-height: 1.1;

        @media screen and (max-width: 768px) {
          font-size: 30px;
        }
        @media screen and (max-width: 480px) {
          font-size: 26px;
        }
        @media screen and (max-width: 360px) {

        }

        .pfeil {
          float: right
        }
      }
    }

  }
}
</style>
